(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offhoo-footer"] && !Shopify.designMode) return;
  try {
    
  class OffhooFooterLanguage extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-trigger]');
      this.panel = this.querySelector('[data-panel]');
      if (!this.trigger || !this.panel) return;

      this.onTriggerClick = () => this.toggle();
      this.onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.close();
      };
      this.onKeyDown = (event) => {
        if (event.key === 'Escape') {
          this.close();
          this.trigger.focus();
        }
      };

      this.trigger.addEventListener('click', this.onTriggerClick);
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.onTriggerClick);
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('keydown', this.onKeyDown);
    }

    get isOpen() {
      return !this.panel?.hasAttribute('hidden');
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.panel.removeAttribute('hidden');
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.panel.setAttribute('hidden', '');
      this.trigger.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('offhoo-footer-language')) {
    customElements.define('offhoo-footer-language', OffhooFooterLanguage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offhoo-product-shelf"] && !Shopify.designMode) return;
  try {
    
  class OffhooProductShelf extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-shelf-scroller]');
      this.previousButton = this.querySelector('[data-shelf-prev]');
      this.nextButton = this.querySelector('[data-shelf-next]');

      this.handlePrevious = () => this.scrollByPage(-1);
      this.handleNext = () => this.scrollByPage(1);
      this.handleScroll = () => this.updateArrows();
      this.handleKeydown = (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.scrollByPage(-1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.scrollByPage(1);
        }
      };

      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.scroller?.addEventListener('scroll', this.handleScroll, { passive: true });
      this.scroller?.addEventListener('keydown', this.handleKeydown);

      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      if (this.scroller) {
        this.resizeObserver.observe(this.scroller);
      }

      this.updateArrows();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.scroller?.removeEventListener('scroll', this.handleScroll);
      this.scroller?.removeEventListener('keydown', this.handleKeydown);
      this.resizeObserver?.disconnect();
    }

    scrollByPage(direction) {
      if (!this.scroller) return;

      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.scroller.scrollBy({
        left: this.scroller.clientWidth * direction,
        behavior,
      });
    }

    updateArrows() {
      if (!this.scroller) return;

      const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth - 2;
      const atStart = this.scroller.scrollLeft <= 2;
      const atEnd = this.scroller.scrollLeft >= maxScroll;

      if (this.previousButton) {
        this.previousButton.disabled = atStart;
      }

      if (this.nextButton) {
        this.nextButton.disabled = maxScroll <= 0 || atEnd;
      }
    }
  }

  if (!customElements.get('offhoo-product-shelf')) {
    customElements.define('offhoo-product-shelf', OffhooProductShelf);
  }

  } catch(e) { console.error(e); }
})();
})();
